import React from "react";
import DataDevis from "../dataDevis";
import DataSolly from "../dataSolly";
import DataAxa from "../dataAxa";
import logo_eco from "../img/Logo eco by assur bon plan.png"
import logo_abp from "../img/Logo assur bon plan.png"
import logo_motard from "../img/motard4.png"
import question_mark from "../img/questionmark.png"

const showAxa = process.env.REACT_APP_SHOW_AXA === 'true'

const TarifRow = (p) => {

    const {bestMatch,comparateur,solly,xena,axa,fma,formule,periodicite,changeParams,detailSwitch,hasXena,hasSolly,hasAxa,hasFma} = p.container

    const w = xena.find( w => w.Z_FORM==p.xenaKey )
    const starRef = ( periodicite == 'M' )?<sup>*</sup>:''
    const starSollyRef = ( periodicite == 'M' )?<sup>**</sup>:''
    const starFmaRef = ( periodicite == 'M' )?<sup>***</sup>:''

    const showXena = hasXena &&( comparateur || bestMatch[p.xenaKey]=='xena' )
    const showSolly = hasSolly && comparateur
    const showAxa = hasAxa &&( comparateur || bestMatch[p.xenaKey]=='axa' )
    const showFma = hasFma &&( comparateur || bestMatch[p.xenaKey]=='fma' )
    const showNothing = ( !comparateur )&&( !( showXena || showSolly || showAxa || showFma ) )

    const axaClassNames = ['tarif']
    if ( formule==p.xenaKey ) axaClassNames.push('selected')
    if ( axa.deprecated ) axaClassNames.push('deprecated')

    const fmaClassNames = ['tarif']
    if ( formule==p.xenaKey ) fmaClassNames.push('selected')
    if ( fma.deprecated ) fmaClassNames.push('deprecated')
    
    return <tr><td onClick={()=>detailSwitch(p.xenaKey)}>{p.children}
    </td>
    {showXena && <td 
            className={( formule==p.xenaKey )?'tarif selected':'tarif'}
            onClick={()=>{ changeParams({'formule':p.xenaKey}) }}
        >
        {( w && +w.Z_MTAN )? <>
            {DataDevis.fancyPrice(( periodicite == 'M' )?w.Z_MTMENS:w.Z_MTAN)} € {starRef}
            {DataDevis.zFormToUniqueDetails[w.Z_FORM] ? <a onClick={(e)=>{detailSwitch(p.xenaKey,'xena');e.stopPropagation()}}>⬤ <u>Voir les garanties uniques de l'offre</u></a> : <></> }
        </> :<i>Non disponible</i>}
    </td>}
    {showSolly && <td 
        className={( formule==p.xenaKey )?'tarif selected':'tarif'}
        onClick={()=>{ changeParams({'formule':p.xenaKey}) }}
        >
        { ( solly.hasTarifs(p.xenaKey)) ? <>
            {DataDevis.fancyPrice(( periodicite == 'M' )?solly.mensuel(p.xenaKey):solly.annuel(p.xenaKey))} € {starSollyRef}
            {DataSolly.zFormToUniqueDetails[p.xenaKey] ? <a onClick={(e)=>{detailSwitch(p.xenaKey,'solly');e.stopPropagation()}}>⬤ <u>Voir les garanties uniques de l'offre</u></a> : <></> }

        </> : <i>Non disponible</i> }
    </td>}
    { showAxa && <td
        className={axaClassNames.join(' ')}
        onClick={()=>{ changeParams({'formule':p.xenaKey}) }}
    >
        { ( axa.hasTarifs(p.xenaKey)) ? <>
            {DataDevis.fancyPrice(( periodicite == 'M' )?axa.mensuel(p.xenaKey):axa.annuel(p.xenaKey))} €
            {DataAxa.zFormToUniqueDetails[p.xenaKey] ? <a onClick={(e)=>{detailSwitch(p.xenaKey,'axa');e.stopPropagation()}}>⬤ <u>Garantie du conducteur offerte !</u></a> : <></> }

        </> : <i>Non disponible</i> }
    </td>}
    { showFma && <td
        className={fmaClassNames.join(' ')}
        onClick={()=>{ changeParams({'formule':p.xenaKey}) }}
    >
        { ( fma.hasTarifs(p.xenaKey)) ? <>
            <i>{fma.synthese(p.xenaKey)}</i>
            {DataDevis.fancyPrice(( periodicite == 'M' )?fma.mensuel(p.xenaKey,true):fma.annuel(p.xenaKey,true))} € {starFmaRef}
            {fma.offre(p.xenaKey)?.garanties ? <a onClick={(e)=>{detailSwitch(p.xenaKey,'fma');e.stopPropagation()}}>⬤ <u>Détails de l'offre</u></a> : <></> }

        </> : <i>Non disponible</i> }
    </td>}
    { showNothing && <td></td> }
    
    </tr>
}

const DetailRow = (p) => {
    return p.unfold.includes(p.xenaKey) ? <tr><td className="formule_details" colSpan={p.nCols+1}>{p.children}</td></tr> : <></>
}

export default class FrontTarif extends React.Component {
    
    constructor(props) {
        super(props);
        this.ref = React.createRef()
        this.state = {
            unfold:[],
            M2:false,
            M3:false,
            M4:false,
            M7:false
        }
    }

    detailSwitch(code,specific=false) {
        if ( this.state.unfold.includes(code) ) {
            if ( this.state[code] == specific ) {
                this.setState({unfold:this.state.unfold.filter(c=>c!=code)})
            } else {
                this.setState({[code]:specific})
            }
        } else {
            this.setState({unfold:[code,...this.state.unfold],[code]:specific})
        }
    }

    renderDetails( zForm ) {
        const {comparateur,bestMatch} = this.props.container
        const what = comparateur ? this.state[zForm] : bestMatch[zForm]
        switch ( what ) {
            case false:
                return DataDevis.zFormToDetails[zForm]
            case 'xena':
                return DataDevis.zFormToUniqueDetails[zForm] || DataDevis.zFormToDetails[zForm]
            case 'solly':
                return DataSolly.zFormToUniqueDetails[zForm] || DataDevis.zFormToDetails[zForm]
            case 'axa':
                return DataAxa.zFormToUniqueDetails[zForm] || DataDevis.zFormToDetails[zForm]
            case 'fma':
                return this.props.container.fma.description(zForm)
        }
        return 'Invalid value for '+zForm+' : '+this.state[zForm]
    }   

    render() {
        const {devis,solly,axa,fma,bestMatch,comparateur,hasFma,focusError,showValidate,changeParams,xena,hasXena,hasSolly,hasAxa} = this.props.container
        const {params} = devis
        const {periodicite,formule} = params
        const sollyFrais = solly ? solly.frais() : 0
        const container = {
            nCols:comparateur?(hasXena?1:0)+(hasSolly?1:0)+(hasAxa?1:0)+(hasFma?1:0):1,
            xena:xena,
            solly:solly,
            fma:fma,
            bestMatch:bestMatch,
            comparateur:comparateur,
            hasFma:hasFma,
            hasXena:hasXena,
            hasSolly:hasSolly,
            hasAxa:hasAxa,
            axa:axa,
            periodicite:periodicite,
            formule:formule,
            changeParams:changeParams,
            detailSwitch:this.detailSwitch.bind(this)
        }

        const anyXena = hasXena &&( comparateur || Object.values(bestMatch).includes('xena') )
        const anyFma = hasFma &&( comparateur || Object.values(bestMatch).includes('fma') )

        let message = devis.validateMessage('formule')
        if ( !message ) message = devis.validateMessage('periodicite')
        if ( message ) focusError(this.ref)
        if ( !showValidate ) message = undefined

        return <><table ref={this.ref} className="comparateur gradiant">
                {comparateur && <thead>
                    <tr><th></th>
                        {hasXena && <th><img src={logo_eco}/></th>}
                        {hasSolly && <th><img src={logo_abp}/></th>}
                        {hasAxa && <th><img src={logo_motard}/></th>}
                        {hasFma && <th>Assur Discount</th>}
                    </tr>
                    {(( hasAxa && axa.deprecated )||( hasFma && fma.deprecated ))&& <tr className="error_row">
                        <th></th>
                        {hasXena && <th></th>}
                        {hasSolly && <th></th>}
                        {hasAxa && axa.deprecated && <th title={axa.deprecated.getCleanError()}><div className="error_box">{axa.deprecated.getCleanError()}</div></th>}
                        {hasFma && fma.deprecated && <th title={fma.deprecated.getCleanError()}><div className="error_box">{fma.deprecated.getCleanError()}</div></th>}
                    </tr>}
                </thead>}
                <tbody>
                    <TarifRow xenaKey="M2" container={container}>
                        <h3>Formule <b>au Tiers</b>
                        <img src={question_mark}/></h3>
                        Responsabilité Civile et Défense Pénale et Recours Suite à Accident
                    </TarifRow>
                    <DetailRow xenaKey="M2" unfold={this.state.unfold} nCols={container.nCols}>
                        {this.renderDetails('M2')}
                    </DetailRow>
                    <TarifRow xenaKey="M3" container={container}>
                        <h3>Formule <b>Tiers + Vol & Incendie</b><img src={question_mark}/></h3>
                        Catastrophes Naturelles, Catastrophes
                        Technologiques, attentats, protection juridique
                    </TarifRow>
                    <DetailRow xenaKey="M3" unfold={this.state.unfold} nCols={container.nCols}>
                        {this.renderDetails('M3')}
                    </DetailRow>
                    <TarifRow xenaKey="M4" container={container}>
                        <h3>Formule Vol + <b>Dommage Collision</b><img src={question_mark}/></h3>
                        Accident avec un tiers identifié
                    </TarifRow>
                    <DetailRow xenaKey="M4" unfold={this.state.unfold} nCols={container.nCols}>
                        {this.renderDetails('M4')}
                    </DetailRow>
                    <TarifRow xenaKey="M7" container={container}>
                        <h3>Formule <b>Tous risques</b><img src={question_mark}/></h3>
                        Dommages tous accidents
                    </TarifRow>
                    <DetailRow xenaKey="M7" unfold={this.state.unfold} nCols={container.nCols}>
                        {this.renderDetails('M7')}
                    </DetailRow>

                </tbody>
            </table>
            {( periodicite=='M' ) && <>
                { anyFma && 
                    <div className="price_notice">*** Prix mensuel, après un premier paiement CB de <b>{fma.fraisCB()} €</b>, renouvelable tous les ans, suivi d'un premier prélevement de <b>{fma.comptantMensuel(formule)} €</b>. Ces deux paiements incluent les frais de gestion et de courtage ainsi que les 2 premiers mois de cotisation.</div>
                }   
                { anyXena &&
                    <div className="price_notice">* Prix mensuel, auquel s'ajoutent <b>{devis.fees()} €</b> de frais de gestion et de courtage à payer à la souscription, renouvelables tous les ans.</div>
                }
                { ( !!sollyFrais )&&
                    <div className="price_notice">** Prix mensuel, 
                    auquel s'ajoutent <b>{DataDevis.fancyPrice(sollyFrais)} €</b> de frais de gestion et de courtage à payer à la souscription, renouvelables tous les ans.</div>
                }
            </>}
        </>
    }
}